import { defineParams } from '@sveltejs/kit/params';
import { get_entry_id_and_title_from_slug, get_user_id_and_name_from_slug } from '#lib/slugs.js';

// A matcher returns the param when it matches, undefined when it doesn't
export const params = defineParams({
	entry_slug: (param) => {
		if (param.startsWith('@')) return;

		const { entry_id, title } = get_entry_id_and_title_from_slug(param);

		// Valid if we have either a entry_id or a title
		if (entry_id !== undefined || title !== undefined) {
			return param;
		}
	},

	user_slug: (param) => {
		const { user_id, name } = get_user_id_and_name_from_slug('@' + param);

		// Valid if we have either a user_id or a name
		if (user_id !== undefined) {
			return param;
		}

		// Additional check to ensure name contains only valid characters
		if (name !== undefined && /^[a-zA-Z]+$/.test(name)) {
			return param;
		}
	}
});
